import { useMemo } from 'react';
import useTranslation from 'next-translate/useTranslation';

import Constants from '@/constants/const';
import { IStoreInfo } from '@/types/homepage';
import { isLatinoChannel } from '@/utils/common/latino-app';
import useHomepage from '@/store/home';

import useGlobalNavHeader from './provider';

/**
 * 与 GlobalNavHeader 一致的门店信息来源：优先 GlobalNavHeaderProvider 的 storeInfo，否则 homepage store。
 * 供顶栏、抽屉内菜单等任意在布局树中的组件复用。
 */
export function useMergedGlobalStoreInfo() {
  const globalNavHeader = useGlobalNavHeader();
  const { store } = useHomepage();
  const { lang } = useTranslation('common');
  const isLatino = isLatinoChannel();

  const { storeInfo: homepageStoreInfo } = store || {};
  const globalStoreInfo: IStoreInfo | undefined = globalNavHeader?.storeInfo || homepageStoreInfo;

  const langMayHaveStore = useMemo(() => {
    if (!isLatino) {
      return lang === Constants.LANGUAGE_EN;
    }
    return lang === Constants.LANGUAGE_EN || lang === Constants.LANGUAGE_ES;
  }, [isLatino, lang]);

  const showStore = !!(globalStoreInfo?.in_test && globalStoreInfo?.select_store);

  return {
    globalStoreInfo,
    showStore,
    langMayHaveStore,
    selectStoreName: globalStoreInfo?.select_store_name,
    lang
  };
}
